// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77800c6c","453":"79360605","732":"ef32fb97","857":"b3be245f","992":"f5ef4b3a"}[chunkId] + ".chunk.js";
};